function n(u, e) {
  return e.children.find((i) => i.userData.uuid === u.uuid);
}
export {
  n as getRgView
};
//# sourceMappingURL=index17.js.map
